import images from "./images";

const schedule = [
    {
        id: 1,
        image: images.session1,
        title: "Game registration and free practice",
        content: "Teams arrived and registrationn. Some categories are open to praceice!",
        details: {
            category: "Technology, AI, Autonomous Vehicles",
            date: "26 November 2025",
            time: "1:00 PM - 6:00 PM",
            venue: "POPOP A1 building.",
            organizer: "",
            number: "",
            email: "",
            entryFee: ""
        },
        paragraphs: [
            // "Explore how AI is transforming the future of autonomous vehicles, from self-learning algorithms to real-time decision-making.",
            // "Gain insights from top industry experts on the challenges, innovations, and breakthroughs in AI-driven transportation technology."
        ],
        gallery: [
            images.session1Gallery1,
            images.session1Gallery2
        ],
        agenda: [
            // "Welcome and Introduction",
            // "AI Innovations in Self-Driving Technology",
            // "Real-Time Decision-Making with AI",
            // "Challenges and Ethical Considerations",
            // "Future of AI in Autonomous Mobility"
        ],
        learningOutcomes: [
            // "Understand AI-driven decision-making in autonomous vehicles.",
            // "Discover real-world applications of AI in self-driving technology.",
            // "Explore ethical and regulatory challenges in AI transportation.",
            // "Learn how sensor fusion enhances autonomous vehicle safety.",
            // "Gain insights into future AI trends in smart mobility."
        ],
        speakerIds: [1, 6],
        locationMap: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d924234.6303368191!2d66.59494515823903!3d25.193389461148573!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3eb33e06651d4bbf%3A0x9cf92f44555a0c23!2sKarachi%2C%20Karachi%20City%2C%20Sindh%2C%20Pakistan!5e0!3m2!1sen!2s!4v1645287442276!5m2!1sen!2s"
    },
    {
        id: 2,
        image: images.session2,
        title: "Opening Ceremony",
        content: "WRG 2025 opening ceremony event and introduce VIPs comes from countries.",
        details: {
            category: "Technology, AI, Healthcare",
            date: "27 November 2025",
            time: "9:00 AM - 9:30 AM",
            venue: "POPOP Taipei",
            organizer: "",
            number: "",
            email: "",
            entryFee: ""
        },
        paragraphs: [
            // "Discover the transformative impact of AI in healthcare, from diagnostics to treatment planning and patient care.",
            // "Join leading experts as they discuss AI-driven advancements in medical imaging, predictive analytics, and personalized medicine."
        ],
        gallery: [
            images.session2Gallery1,
            images.session2Gallery2
        ],
        agenda: [
            "Opening Remarks",
            "AI-Powered Diagnostics and Imaging",
            "Machine Learning in Drug Discovery",
            "Ethical and Privacy Concerns in AI Healthcare",
            "Future Trends in AI-Driven Healthcare"
        ],
        learningOutcomes: [
            "Understand AI's role in enhancing medical diagnostics and imaging.",
            "Explore how machine learning is accelerating drug discovery.",
            "Gain insights into ethical and privacy challenges in AI healthcare.",
            "Learn how AI-driven predictive analytics improve patient outcomes.",
            "Discover emerging trends shaping the future of AI in medicine."
        ],
        speakerIds: [1, 6],
        locationMap: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d924234.6303368191!2d66.59494515823903!3d25.193389461148573!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3eb33e06651d4bbf%3A0x9cf92f44555a0c23!2sKarachi%2C%20Karachi%20City%2C%20Sindh%2C%20Pakistan!5e0!3m2!1sen!2s!4v1645287442276!5m2!1sen!2s"
    },
    {
        id: 3,
        image: images.session3,
        title: "Official Competition",
        content: "",
        details: {
            category: "",
            date: "27 November 2025",
            time: "9:30 PM - 6:00 PM",
            venue: "POPOP TAIPEI",
            organizer: "",
            number: "",
            email: "",
            entryFee: ""
        },
        paragraphs: [
            // "Discover how machine learning is transforming cybersecurity, from threat detection to real-time risk mitigation.",
            // "Join cybersecurity experts to explore AI-driven defense strategies, anomaly detection, and the future of cyber protection."
        ],
        gallery: [
            images.session3Gallery1,
            images.session3Gallery2
        ],
        agenda: [
            // "Introduction to AI in Cybersecurity",
            // "Machine Learning for Threat Detection",
            // "AI-Powered Fraud Prevention",
            // "Ethical Considerations in AI Security",
            // "The Future of AI-Driven Cyber Defense"
        ],
        learningOutcomes: [
            // "Understand how AI improves cybersecurity threat detection.",
            // "Explore machine learning techniques for identifying cyber threats.",
            // "Learn about AI-driven fraud detection and prevention methods.",
            // "Gain insights into ethical and legal challenges in AI security.",
            // "Discover future trends in AI-based cybersecurity strategies."
        ],
        speakerIds: [1, 6],
        locationMap: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d924234.6303368191!2d66.59494515823903!3d25.193389461148573!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3eb33e06651d4bbf%3A0x9cf92f44555a0c23!2sKarachi%2C%20Karachi%20City%2C%20Sindh%2C%20Pakistan!5e0!3m2!1sen!2s!4v1645287442276!5m2!1sen!2s"
    },
    {
        id: 4,
        image: images.session3,
        title: "ONE MINUTE GAME CATEGORY START",
        content: "",
        details: {
            category: "",
            date: "27 November 2025",
            time: "11:30 PM - 4:00 PM",
            venue: "POPOP TAIPEI",
            organizer: "",
            number: "",
            email: "",
            entryFee: ""
        },
        paragraphs: [
            // "Discover how machine learning is transforming cybersecurity, from threat detection to real-time risk mitigation.",
            // "Join cybersecurity experts to explore AI-driven defense strategies, anomaly detection, and the future of cyber protection."
        ],
        gallery: [
            images.session3Gallery1,
            images.session3Gallery2
        ],
        agenda: [
            // "Introduction to AI in Cybersecurity",
            // "Machine Learning for Threat Detection",
            // "AI-Powered Fraud Prevention",
            // "Ethical Considerations in AI Security",
            // "The Future of AI-Driven Cyber Defense"
        ],
        learningOutcomes: [
            // "Understand how AI improves cybersecurity threat detection.",
            // "Explore machine learning techniques for identifying cyber threats.",
            // "Learn about AI-driven fraud detection and prevention methods.",
            // "Gain insights into ethical and legal challenges in AI security.",
            // "Discover future trends in AI-based cybersecurity strategies."
        ],
        speakerIds: [1, 6],
        locationMap: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d924234.6303368191!2d66.59494515823903!3d25.193389461148573!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3eb33e06651d4bbf%3A0x9cf92f44555a0c23!2sKarachi%2C%20Karachi%20City%2C%20Sindh%2C%20Pakistan!5e0!3m2!1sen!2s!4v1645287442276!5m2!1sen!2s"
    },
    {
        id: 5,
        image: images.session3,
        title: "ONE MINUTE GAME CATEGORY",
        content: "",
        details: {
            category: "",
            date: "27 November 2025",
            time: "11:30 PM - 4:00 PM",
            venue: "POPOP TAIPEI",
            organizer: "",
            number: "",
            email: "",
            entryFee: ""
        },
        paragraphs: [
            // "Discover how machine learning is transforming cybersecurity, from threat detection to real-time risk mitigation.",
            // "Join cybersecurity experts to explore AI-driven defense strategies, anomaly detection, and the future of cyber protection."
        ],
        gallery: [
            images.session3Gallery1,
            images.session3Gallery2
        ],
        agenda: [
            // "Introduction to AI in Cybersecurity",
            // "Machine Learning for Threat Detection",
            // "AI-Powered Fraud Prevention",
            // "Ethical Considerations in AI Security",
            // "The Future of AI-Driven Cyber Defense"
        ],
        learningOutcomes: [
            // "Understand how AI improves cybersecurity threat detection.",
            // "Explore machine learning techniques for identifying cyber threats.",
            // "Learn about AI-driven fraud detection and prevention methods.",
            // "Gain insights into ethical and legal challenges in AI security.",
            // "Discover future trends in AI-based cybersecurity strategies."
        ],
        speakerIds: [1, 6],
        locationMap: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d924234.6303368191!2d66.59494515823903!3d25.193389461148573!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3eb33e06651d4bbf%3A0x9cf92f44555a0c23!2sKarachi%2C%20Karachi%20City%2C%20Sindh%2C%20Pakistan!5e0!3m2!1sen!2s!4v1645287442276!5m2!1sen!2s"
    },
    {
        id: 5,
        image: images.session3,
        title: "Sumo Robot Junior FIRST ROUND",
        content: "",
        details: {
            category: "",
            date: "27 November 2025",
            time: "1:00 PM - 5:00 PM",
            venue: "POPOP TAIPEI",
            organizer: "",
            number: "",
            email: "",
            entryFee: ""
        },
        paragraphs: [
            // "Discover how machine learning is transforming cybersecurity, from threat detection to real-time risk mitigation.",
            // "Join cybersecurity experts to explore AI-driven defense strategies, anomaly detection, and the future of cyber protection."
        ],
        gallery: [
            images.session3Gallery1,
            images.session3Gallery2
        ],
        agenda: [
            // "Introduction to AI in Cybersecurity",
            // "Machine Learning for Threat Detection",
            // "AI-Powered Fraud Prevention",
            // "Ethical Considerations in AI Security",
            // "The Future of AI-Driven Cyber Defense"
        ],
        learningOutcomes: [
            // "Understand how AI improves cybersecurity threat detection.",
            // "Explore machine learning techniques for identifying cyber threats.",
            // "Learn about AI-driven fraud detection and prevention methods.",
            // "Gain insights into ethical and legal challenges in AI security.",
            // "Discover future trends in AI-based cybersecurity strategies."
        ],
        speakerIds: [1, 6],
        locationMap: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d924234.6303368191!2d66.59494515823903!3d25.193389461148573!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3eb33e06651d4bbf%3A0x9cf92f44555a0c23!2sKarachi%2C%20Karachi%20City%2C%20Sindh%2C%20Pakistan!5e0!3m2!1sen!2s!4v1645287442276!5m2!1sen!2s"
    },
    {
        id: 5,
        image: images.session3,
        title: "Rescue Robot Category",
        content: "",
        details: {
            category: "",
            date: "27 November 2025",
            time: "1:00 PM - 5:00 PM",
            venue: "POPOP TAIPEI",
            organizer: "",
            number: "",
            email: "",
            entryFee: ""
        },
        paragraphs: [
            // "Discover how machine learning is transforming cybersecurity, from threat detection to real-time risk mitigation.",
            // "Join cybersecurity experts to explore AI-driven defense strategies, anomaly detection, and the future of cyber protection."
        ],
        gallery: [
            images.session3Gallery1,
            images.session3Gallery2
        ],
        agenda: [
            // "Introduction to AI in Cybersecurity",
            // "Machine Learning for Threat Detection",
            // "AI-Powered Fraud Prevention",
            // "Ethical Considerations in AI Security",
            // "The Future of AI-Driven Cyber Defense"
        ],
        learningOutcomes: [
            // "Understand how AI improves cybersecurity threat detection.",
            // "Explore machine learning techniques for identifying cyber threats.",
            // "Learn about AI-driven fraud detection and prevention methods.",
            // "Gain insights into ethical and legal challenges in AI security.",
            // "Discover future trends in AI-based cybersecurity strategies."
        ],
        speakerIds: [1, 6],
        locationMap: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d924234.6303368191!2d66.59494515823903!3d25.193389461148573!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3eb33e06651d4bbf%3A0x9cf92f44555a0c23!2sKarachi%2C%20Karachi%20City%2C%20Sindh%2C%20Pakistan!5e0!3m2!1sen!2s!4v1645287442276!5m2!1sen!2s"
    },
    {
        id: 5,
        image: images.session3,
        title: "Line Tracing Category",
        content: "",
        details: {
            category: "",
            date: "27 November 2025",
            time: "1:00 PM - 5:00 PM",
            venue: "POPOP TAIPEI",
            organizer: "",
            number: "",
            email: "",
            entryFee: ""
        },
        paragraphs: [
            // "Discover how machine learning is transforming cybersecurity, from threat detection to real-time risk mitigation.",
            // "Join cybersecurity experts to explore AI-driven defense strategies, anomaly detection, and the future of cyber protection."
        ],
        gallery: [
            images.session3Gallery1,
            images.session3Gallery2
        ],
        agenda: [
            // "Introduction to AI in Cybersecurity",
            // "Machine Learning for Threat Detection",
            // "AI-Powered Fraud Prevention",
            // "Ethical Considerations in AI Security",
            // "The Future of AI-Driven Cyber Defense"
        ],
        learningOutcomes: [
            // "Understand how AI improves cybersecurity threat detection.",
            // "Explore machine learning techniques for identifying cyber threats.",
            // "Learn about AI-driven fraud detection and prevention methods.",
            // "Gain insights into ethical and legal challenges in AI security.",
            // "Discover future trends in AI-based cybersecurity strategies."
        ],
        speakerIds: [1, 6],
        locationMap: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d924234.6303368191!2d66.59494515823903!3d25.193389461148573!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3eb33e06651d4bbf%3A0x9cf92f44555a0c23!2sKarachi%2C%20Karachi%20City%2C%20Sindh%2C%20Pakistan!5e0!3m2!1sen!2s!4v1645287442276!5m2!1sen!2s"
    },
    {
        id: 3,
        image: images.session3,
        title: "Official Competition",
        content: "",
        details: {
            category: "",
            date: "27 November 2025",
            time: "9:30 PM - 6:00 PM",
            venue: "POPOP TAIPEI",
            organizer: "",
            number: "",
            email: "",
            entryFee: ""
        },
        paragraphs: [
            // "Discover how machine learning is transforming cybersecurity, from threat detection to real-time risk mitigation.",
            // "Join cybersecurity experts to explore AI-driven defense strategies, anomaly detection, and the future of cyber protection."
        ],
        gallery: [
            images.session3Gallery1,
            images.session3Gallery2
        ],
        agenda: [
            // "Introduction to AI in Cybersecurity",
            // "Machine Learning for Threat Detection",
            // "AI-Powered Fraud Prevention",
            // "Ethical Considerations in AI Security",
            // "The Future of AI-Driven Cyber Defense"
        ],
        learningOutcomes: [
            // "Understand how AI improves cybersecurity threat detection.",
            // "Explore machine learning techniques for identifying cyber threats.",
            // "Learn about AI-driven fraud detection and prevention methods.",
            // "Gain insights into ethical and legal challenges in AI security.",
            // "Discover future trends in AI-based cybersecurity strategies."
        ],
        speakerIds: [1, 6],
        locationMap: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d924234.6303368191!2d66.59494515823903!3d25.193389461148573!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3eb33e06651d4bbf%3A0x9cf92f44555a0c23!2sKarachi%2C%20Karachi%20City%2C%20Sindh%2C%20Pakistan!5e0!3m2!1sen!2s!4v1645287442276!5m2!1sen!2s"
    },
    {
        id: 4,
        image: images.session4,
        title: "Final Days of Offical Competition",
        content: "Explore how AI is transforming urban living, from traffic management to smart energy solutions.",
        details: {
            category: "",
            date: "28 November 2025",
            time: "9:00 AM - 6:00 PM",
            venue: "POPOP TAIPEI",
            organizer: "",
            number: "",
            email: "",
            entryFee: ""
        },
        paragraphs: [
            // "Discover how AI is revolutionizing urban environments, improving infrastructure, and enhancing city-wide efficiency.",
            // "Join leading experts to discuss AI-driven traffic management, energy optimization, and the future of intelligent urban planning."
        ],
        gallery: [
            images.session4Gallery1,
            images.session4Gallery2
        ],
        agenda: [
            // "Introduction to AI in Smart Cities",
            // "AI-Powered Traffic and Transportation Systems",
            // "Smart Energy Management with AI",
            // "Challenges and Ethical Considerations",
            // "Future Trends in AI-Driven Urban Development"
        ],
        learningOutcomes: [
            // "Understand AI’s impact on smart city infrastructure.",
            // "Learn how AI optimizes traffic and public transportation.",
            // "Explore AI-driven energy efficiency and sustainability.",
            // "Discover the role of AI in smart governance and security.",
            // "Gain insights into the future of AI-powered urban planning."
        ],
        speakerIds: [1, 6],
        locationMap: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d924234.6303368191!2d66.59494515823903!3d25.193389461148573!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3eb33e06651d4bbf%3A0x9cf92f44555a0c23!2sKarachi%2C%20Karachi%20City%2C%20Sindh%2C%20Pakistan!5e0!3m2!1sen!2s!4v1645287442276!5m2!1sen!2s"
    },
    {
        id: 5,
        image: images.session5,
        title: "Innovation Category: carry out review work",
        content: "Year Threme: AI robotic.",
        details: {
            category: "Innovation Category",
            date: "28 November 2025",
            time: "10:00 AM - 16:00 PM",
            venue: "POPOP TAIPEI",
            organizer: "",
            number: "",
            email: "",
            entryFee: ""
        },
        paragraphs: [
            // "Explore how AI is revolutionizing education by personalizing learning experiences for students of all levels.",
            // "Join experts in AI and education technology to discuss adaptive learning systems, AI-driven tutoring, and the future of personalized education."
        ],
        gallery: [
            images.session5Gallery1,
            images.session5Gallery2
        ],
        agenda: [
            // "Introduction to AI in Education",
            // "Adaptive Learning Systems and AI",
            // "AI-Powered Personalized Tutoring",
            // "Ethical and Privacy Concerns in AI Education",
            // "Future Trends in AI-Driven Learning"
        ],
        learningOutcomes: [
            // "Understand AI's role in personalized learning experiences.",
            // "Learn how AI adapts content based on student progress.",
            // "Explore AI-powered tutoring and smart assessments.",
            // "Discover ethical considerations in AI-driven education.",
            // "Gain insights into future trends in AI education."
        ],
        speakerIds: [1, 6],
        locationMap: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d924234.6303368191!2d66.59494515823903!3d25.193389461148573!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3eb33e06651d4bbf%3A0x9cf92f44555a0c23!2sKarachi%2C%20Karachi%20City%2C%20Sindh%2C%20Pakistan!5e0!3m2!1sen!2s!4v1645287442276!5m2!1sen!2s"
    },
    {
        id: 6,
        image: images.session6,
        title: "incredible Machine Category: carry out review work",
        content: "",
        details: {
            category: "Incredibile Machine",
            date: "28 November 2025",
            time: "10:00 AM - 16:00 PM",
            venue: "POPOP TAIPEI",
            organizer: "",
            number: "",
            email: "",
            entryFee: ""
        },
        paragraphs: [
            // "Discover how AI is revolutionizing robotics, from autonomous machines to intelligent automation in various industries.",
            // "Join industry experts to discuss real-world AI applications in robotics, from healthcare and manufacturing to space exploration and smart assistants."
        ],
        gallery: [
            images.session6Gallery1,
            images.session6Gallery2
        ],
        agenda: [
            // "Introduction to AI in Robotics",
            // "Machine Learning for Robotics",
            // "Autonomous Systems and AI",
            // "AI-Powered Robotics in Industry",
            // "Future Innovations in AI Robotics"
        ],
        learningOutcomes: [
            // "Understand how AI enhances robotic automation.",
            // "Learn about AI-driven decision-making in robotics.",
            // "Explore real-world applications of AI in robotics.",
            // "Discover the role of AI in autonomous robotic systems.",
            // "Gain insights into the future of AI-powered robotics."
        ],
        speakerIds: [1, 6],
        locationMap: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d924234.6303368191!2d66.59494515823903!3d25.193389461148573!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3eb33e06651d4bbf%3A0x9cf92f44555a0c23!2sKarachi%2C%20Karachi%20City%2C%20Sindh%2C%20Pakistan!5e0!3m2!1sen!2s!4v1645287442276!5m2!1sen!2s"
    },
    {
        id: 7,
        image: images.session7,
        title: "Celebration Dinner",
        content: "",
        details: {
            category: "",
            date: "28 November 2025",
            time: "6:30 PM - 9:00 PM",
            venue: "Announced soon...",
            organizer: "",
            number: "",
            email: "",
            entryFee: ""
        },
        paragraphs: [
            // "Explore how AI is transforming augmented reality by making interactions more intuitive, immersive, and intelligent.",
            // "Join leading experts to learn about AI-powered AR applications in gaming, retail, education, healthcare, and more."
        ],
        gallery: [
            images.session7Gallery1,
            images.session7Gallery2
        ],
        agenda: [
            // "Introduction to AI and AR",
            // "AI-Driven AR Experiences",
            // "Machine Learning in Augmented Reality",
            // "AI-Powered AR in Industries",
            // "Future of AI and AR Integration"
        ],
        learningOutcomes: [
            // "Understand the role of AI in enhancing AR experiences.",
            // "Learn about AI-driven AR applications across industries.",
            // "Discover machine learning techniques used in AR.",
            // "Explore real-world use cases of AI-powered AR.",
            // "Gain insights into the future of AI and AR innovation."
        ],
        speakerIds: [1, 6],
        locationMap: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d924234.6303368191!2d66.59494515823903!3d25.193389461148573!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3eb33e06651d4bbf%3A0x9cf92f44555a0c23!2sKarachi%2C%20Karachi%20City%2C%20Sindh%2C%20Pakistan!5e0!3m2!1sen!2s!4v1645287442276!5m2!1sen!2s"
    },
    {
        id: 8,
        image: images.session8,
        title: "Awards Ceremony",
        content: "",
        details: {
            category: "",
            date: "29 November 2025",
            time: "9:00 AM - 12:00 PM",
            venue: "POPOP TAIPEI",
            organizer: "",
            number: "",
            email: "",
            entryFee: ""
        },
        paragraphs: [
            // "Discover how AI is transforming financial markets with advanced analytics, predictive modeling, and real-time decision-making.",
            // "Gain insights into the impact of AI on trading strategies, fraud detection, risk assessment, and the future of financial technology."
        ],
        gallery: [
            images.session8Gallery1,
            images.session8Gallery2
        ],
        agenda: [
            // "Introduction to AI in Finance",
            // "Algorithmic Trading and AI",
            // "Predictive Analytics in Financial Markets",
            // "AI-Driven Risk Management",
            // "Future Trends in AI and Finance"
        ],
        learningOutcomes: [
            // "Understand how AI enhances financial decision-making.",
            // "Explore AI applications in trading and investment.",
            // "Learn about AI-driven fraud detection techniques.",
            // "Discover how AI improves risk management strategies.",
            // "Gain insights into the future of AI in fintech."
        ],
        speakerIds: [1, 6],
        locationMap: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d924234.6303368191!2d66.59494515823903!3d25.193389461148573!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3eb33e06651d4bbf%3A0x9cf92f44555a0c23!2sKarachi%2C%20Karachi%20City%2C%20Sindh%2C%20Pakistan!5e0!3m2!1sen!2s!4v1645287442276!5m2!1sen!2s"
    },

    {
        id: 9,
        image: images.session9,
        title: "Visit Maker Faire Taipei event",
        content: "",
        details: {
            category: "",
            date: "29 November 2025",
            time: "12:00 PM - 6:00 PM",
            venue: "POPOP TAIPEI",
            organizer: "",
            number: "",
            email: "",
            entryFee: ""
        },
        paragraphs: [
            // "Discover how AI is revolutionizing agriculture by improving efficiency, reducing waste, and increasing productivity.",
            // "Learn about AI-driven predictive analytics, precision farming, and smart irrigation techniques that are transforming modern agriculture."
        ],
        gallery: [
            images.session9Gallery1,
            images.session9Gallery2
        ],
        agenda: [
            // "Introduction to AI in Agriculture",
            // "Precision Farming with AI",
            // "AI-Based Crop Monitoring and Pest Control",
            // "Smart Irrigation and Water Management",
            // "Future Trends in AI-Driven Farming"
        ],
        learningOutcomes: [
            // "Understand AI-driven precision farming techniques.",
            // "Learn how AI optimizes crop monitoring and pest control.",
            // "Explore smart irrigation and water management solutions.",
            // "Discover AI applications in soil analysis and yield prediction.",
            // "Gain insights into the future of AI in sustainable agriculture."
        ],
        speakerIds: [1, 6],
        locationMap: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d924234.6303368191!2d66.59494515823903!3d25.193389461148573!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3eb33e06651d4bbf%3A0x9cf92f44555a0c23!2sKarachi%2C%20Karachi%20City%2C%20Sindh%2C%20Pakistan!5e0!3m2!1sen!2s!4v1645287442276!5m2!1sen!2s"
    },

    {
        id: 10,
        image: images.session10,
        title: "Innovation / Incredible works setup",
        content: "",
        details: {
            category: "",
            date: "27 November 2025",
            time: "9:00 PM - 6:00 PM",
            venue: "POPOP TAIPEI",
            organizer: "",
            number: "",
            email: "",
            entryFee: ""
        },
        paragraphs: [
            // "Discover how AI is revolutionizing agriculture by improving efficiency, reducing waste, and increasing productivity.",
            // "Learn about AI-driven predictive analytics, precision farming, and smart irrigation techniques that are transforming modern agriculture."
        ],
        gallery: [
            images.session9Gallery1,
            images.session9Gallery2
        ],
        agenda: [
            // "Introduction to AI in Agriculture",
            // "Precision Farming with AI",
            // "AI-Based Crop Monitoring and Pest Control",
            // "Smart Irrigation and Water Management",
            // "Future Trends in AI-Driven Farming"
        ],
        learningOutcomes: [
            // "Understand AI-driven precision farming techniques.",
            // "Learn how AI optimizes crop monitoring and pest control.",
            // "Explore smart irrigation and water management solutions.",
            // "Discover AI applications in soil analysis and yield prediction.",
            // "Gain insights into the future of AI in sustainable agriculture."
        ],
        speakerIds: [1, 6],
        locationMap: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d924234.6303368191!2d66.59494515823903!3d25.193389461148573!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3eb33e06651d4bbf%3A0x9cf92f44555a0c23!2sKarachi%2C%20Karachi%20City%2C%20Sindh%2C%20Pakistan!5e0!3m2!1sen!2s!4v1645287442276!5m2!1sen!2s"
    }

]

export default schedule;